import { Assessment } from '../../types/assessments/assessment'
import { mergeData } from '../data'
export const mergeAssessmentSignOnData = (assessment?: Assessment) =>
  mergeData(assessment?.signOnData ?? {}, assessment?.signOnCorrections ?? {})
